export enum EChannelKeys {
  LOGIN_AGAIN = 'login-again',
  UPDATE_USER_DATA = 'update-user-data',
}
